<ng-container *ngIf="tableConfig$ | async as tableConfig">
  <app-grid-quick-filter
    *ngIf="showQuickFilter"
    [configStoreTableName]="configStoreTableName"
    [configStoreRouteIdName]="configStoreRouteIdName"
    [tagsMode]="tagsMode"
  ></app-grid-quick-filter>

  <div *ngIf="showDateFilter">
    <div class="datepicker-container">
      <div class="filter-dates-container">
        <mat-form-field class="adap-form-range-input" appearance="outline">
          <mat-date-range-input
            [formGroup]="filterDates"
            [rangePicker]="filterDatesPicker"
          >
            <input
              matStartDate
              placeholder="Start date"
              formControlName="start"
            />
            <input
              matEndDate
              placeholder="End date"
              formControlName="end"
              (dateChange)="onFilterDatesChanged()"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="filterDatesPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker-toggle matSuffix (click)="clearDates()">
            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
          </mat-datepicker-toggle>
          <mat-date-range-picker #filterDatesPicker></mat-date-range-picker>
        </mat-form-field>
      </div>
  </div>
  </div>

  <app-column-list-dropdown
    *ngIf="showColumnsDropdown"
    [configStoreTableName]="configStoreTableName"
    [configStoreRouteIdName]="configStoreRouteIdName"
  ></app-column-list-dropdown>

  <app-table-actions
    [configStoreTableName]="configStoreTableName"
    [configStoreRouteIdName]="configStoreRouteIdName"
    [disableColumnSizeStrategies]="disableColumnSizeStrategies"
    [disableExportToCsv]="disableExportToCsv"
    [tableConfig]="tableConfig"
  >
  </app-table-actions>
</ng-container>
